import React from "react";
import "../Guides/guides.css";
import Seo from "../Seo.jsx";
import mainConfig from "../../config/mainConfig";

const Privacy = () => {
  const meta = mainConfig.disclaimer?.seo || {};

  return (
    <div className="guides-content guides-content-pad">
                   <Seo title={meta.title} description={meta.description} url={meta.route}/>

 <h1>Disclaimer</h1>
  <p>This website is intended solely for informational and entertainment purposes. The content provided, including any calculators, tools, or matched betting advice, is based on the personal opinions and research of the website owner. While every effort has been made to ensure the information is accurate and up-to-date, no guarantee is made regarding its accuracy, completeness, or reliability.</p>
  
  <h2>Entertainment and Informational Purposes Only</h2>
  <ul>
    <li>The calculators and tools displayed on this website are for entertainment purposes only. Their results are estimates and should not be solely relied upon for making any financial or betting decisions.</li>
    <li>The content provided is intended to inform and entertain and does not constitute professional advice. You should always conduct your own research.</li>
  </ul>
  
  <h2>Risk and Responsibility</h2>
  <ul>
    <li>Matched betting involves inherent risks. The website owner does not assume any liability for any losses or damages arising from the use of the information provided on this website.</li>
    <li>Always gamble responsibly. Betting activities should only be undertaken by individuals who fully understand the risks involved. Never bet more than you can afford to lose, and if you feel that your gambling is becoming a problem, seek help immediately.</li>
  </ul>
  
  <h2>No Endorsement or Guarantee</h2>
  <ul>
    <li>Any reference to third-party websites, services, or betting platforms does not constitute an endorsement or guarantee of their services. Users are encouraged to review the terms and conditions and seek independent advice before engaging with any third-party services.</li>
    <li>The website owner is not affiliated with, sponsored by, or endorsed by any betting companies or gambling regulatory authorities unless explicitly stated.</li>
  </ul>
  
  <h2>User Responsibility</h2>
  <ul>
    <li>By using this website, you acknowledge that you are solely responsible for your actions and decisions regarding any bets or financial transactions.</li>
    <li>The website owner is not responsible for any errors or omissions in the content, or for any actions taken in reliance on the information provided.</li>
  </ul>
  
  <h2>Changes to the Disclaimer</h2>
  <p>This disclaimer is subject to change without notice. It is your responsibility to review this disclaimer periodically for any updates. Continued use of the website constitutes your acceptance of any changes to this disclaimer.</p>
    </div>
  );
};

export default Privacy;